import React from 'react';
import { motion } from 'framer-motion';
import { Sprout } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
  showIcon?: boolean;
}
const variantClasses: Record<'primary' | 'secondary', string> = {
  primary: 'text-white bg-leaf hover:bg-forest shadow-lg shadow-leaf/30 border-2 border-leaf hover:border-forest',
  secondary: 'text-forest bg-white hover:bg-sage-50 shadow-sm border-2 border-forest'
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  href,
  target,
  rel,
  onLinkClick,
  showIcon = true,
  ...props
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-extrabold uppercase tracking-wide rounded-xl transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-leaf focus-visible:ring-offset-2 ${variantClasses[variant]}`;
  const content = <>
      <span data-id="element-51" data-mp="hzibmpidy7oc">{children}</span>
      {showIcon && variant === 'primary' && <Sprout className="w-[1.1em] h-[1.1em] shrink-0" aria-hidden="true" data-id="element-52" data-mp="3c5owxgudvwd" />}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-53" data-mp="89flcx2nf7tp">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-54" data-mp="3lhioahyvz18a">
      {content}
    </motion.button>;
}